export default __webpack_public_path__ + "ecc5632dac8c50479618bcae3ab92ea7.mp3";